import script from "./UserMessageDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UserMessageDialog.vue?vue&type=script&setup=true&lang=js"

import "./UserMessageDialog.vue?vue&type=style&index=0&id=6919fe4c&scoped=true&lang=css"

import exportComponent from "D:\\_A-Project\\KoManga\\Ko-Manga-Center-Ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6919fe4c"]])

export default __exports__